import React, { InputHTMLAttributes, memo } from "react";
import styled from "styled-components";
import { inputType } from "../../models/element";

/**
|--------------------------------------------------
| 共通部品 - インプット
|
| ★使用例
| const [val, setVal] = useInitText();
| const handleChange = (val: string) => {
|     setVal(val);
| };
| 
| <PuiInput inputType="thin" placeholder="文字を入力して下さい" value={val} handleChange={handleChange} />
|--------------------------------------------------
*/
interface PuiInputProps extends InputHTMLAttributes<HTMLInputElement> {
    // タイプ
    inputType?: inputType;
    // inputイベント
    handleChange?: (value: string) => void;
}

const StyledInput = styled.input`
    padding: 17px 20px;
    border-right: none;
    border-bottom: 1px solid #2f3538;
    width: 100%;
    height: 40px;
    background: var(--textfield-bg);
    font-family: "游ゴシック体", YuGothic, "游ゴシック Medium", "Yu Gothic Medium", "游ゴシック",
        "Yu Gothic", sans-serif;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    color: var(--gray-80);
    resize: none;
    outline: none;
    border-radius: 5px 5px 0px 0px;
    &: hover {
        background: #ffffff0d;
    }
    &: focus {
        background: var(--textfield-bg);
    }
`;

const StyledInputThin = styled(StyledInput)`
    border: 1px solid var(--gray-38);
`;

function PuiInput({ inputType = "normal", handleChange, ...props }: PuiInputProps) {
    return (
        <>
            {inputType === "normal" && (
                <StyledInput
                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                        if (handleChange) {
                            handleChange(String(event.target.value));
                        }
                    }}
                    {...props}
                />
            )}

            {inputType === "thin" && (
                <StyledInputThin
                    onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
                        if (handleChange) {
                            handleChange(String(event.target.value));
                        }
                    }}
                    {...props}
                />
            )}
        </>
    );
}

export default memo(PuiInput);
